export default __webpack_public_path__ + "static/media/vase.b091e160.png";